import { Heading } from 'components'
import React, { useState } from 'react'
import StorageService from 'utils/StorageServices';
import { CommonReportFilters } from '..';
import moment from 'moment';
import { API, AppConfig } from 'lib';

const VehicleExelProfitReport = () => {

  const [loading, setLoading] = useState(false);
  let isToken = localStorage.getItem("token");

  const currentDate = new Date();
  const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

  const [filter, setFilter] = useState({
    company_id: '',
    start_date: moment(firstDay).subtract(31, 'days'),
    end_date: moment(lastDay),
    vehicle_id: '',
  });

  const getDownloadTripDetailsReports = async () => {
    setLoading(true)
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        vehicle_id: filter?.vehicle_id?.value ? filter?.vehicle_id?.value : '',
        start_date: moment(filter.start_date).format("YYYY-MM-DD"),
        end_date: moment(filter.end_date).format("YYYY-MM-DD"),
      }
      const response = await fetch(`${AppConfig.api_baseurl}${API.VEHICLE_PROFIT_REPORT}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Token': `${isToken}`,
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Vehicle Profit Report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  return (
    <>
      <Heading title="Vehicle Profit Report" />
      <div className='_mrktLoad_mainBx __main_p_n_l _trpRevenue _ctLoad_cts _ctBx_mainBx'>

        <CommonReportFilters
          filter={filter}
          setFilter={(e) => setFilter(e)}
          isPartyDropdown={false}
          isBranchDropdown={false}
          isVehicleOwnershipDropdown={false}
          isSupplierDropdown={false}
          isFromStationDropdown={false}
          isToStationDropdown={false}
          isPodStatusDropdown={false}
          isEwayBillStatusDropdown={false}
          isDriverDropdown={false}
          isStatusDropdown={false}
        />

      </div>

      <div className='paginationFt_avt' style={{ justifyContent: "flex-start", alignItems: "center" }}>
        <button className='_addComm_btn' onClick={(e) => getDownloadTripDetailsReports(e)} disabled={!filter?.vehicle_id?.value || loading}> {loading ? 'Loading...' : 'Download'} </button>
      </div>
    </>
  )
}

export default VehicleExelProfitReport